export const AdminAccountsPermissions = {
  AdminAccountsPermissions: {
    permissionsId: '9746b2f2-79b3-4119-ee43-08da65738802',
    permissionsName: 'Admin Accounts',
    componentsId: null,
    components: null
  },
};
